import axios from "axios";
import { useMemo } from "react";
import { useAuth } from "@clerk/react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const KEY = "gw_2fa_token";

export const twofa = {
  get: () => sessionStorage.getItem(KEY),
  set: (t) => sessionStorage.setItem(KEY, t),
  clear: () => sessionStorage.removeItem(KEY),
};

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const t = await getToken();
      cfg.headers.Authorization = `Bearer ${t}`;
      const f = twofa.get();
      if (f) cfg.headers["X-2FA-Token"] = f;
      return cfg;
    });
    inst.interceptors.response.use(
      (r) => r,
      (err) => {
        if (err.response?.status === 401 && err.response?.data?.detail === "2fa_required") {
          twofa.clear();
          window.dispatchEvent(new Event("2fa-expired"));
        }
        return Promise.reject(err);
      }
    );
    return inst;
  }, [getToken]);
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join("; ");
  return d || "Algo deu errado. Tente novamente.";
};

export const brl = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "—";
